import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  QUESTION_LIST_INCREMENT_COOKIE: 'QUESTION_LIST_INCREMENT_COOKIE',
  QUESTION_LIST_INCREMENT_COOKIE_SUCCESS:
    'QUESTION_LIST_INCREMENT_COOKIE_SUCCESS',
  CHAT_INCREMENT_COOKIE: 'CHAT_INCREMENT_COOKIE',
  CHAT_INCREMENT_COOKIE_SUCCESS: 'CHAT_INCREMENT_COOKIE_SUCCESS',
  SKIP_CHAT_INCREMENT_COOKIE: 'SKIP_CHAT_INCREMENT_COOKIE',
  SKIP_CHAT_INCREMENT_COOKIE_SUCCESS: 'SKIP_CHAT_INCREMENT_COOKIE_SUCCESS',
};

export const questionListIncrementCookie = () => ({
  type: types.QUESTION_LIST_INCREMENT_COOKIE,
});

export const questionListIncrementCookieSuccess = (currentStage) => ({
  type: types.QUESTION_LIST_INCREMENT_COOKIE_SUCCESS,
  payload: {
    currentStage,
  },
});

export const chatIncrementCookie = () => ({
  type: types.CHAT_INCREMENT_COOKIE,
});

export const chatIncrementCookieSuccess = (currentStage) => ({
  type: types.CHAT_INCREMENT_COOKIE_SUCCESS,
  payload: {
    currentStage,
  },
});

export const skipChatIncrementCookie = (currentStage) => ({
  type: types.SKIP_CHAT_INCREMENT_COOKIE,
  payload: {
    currentStage,
  },
});

const INIT_STATE = {
  status: loadingState.EMPTY,
  questionListCurrentStage: 0,
  chatCurrentStage: 0,
};

function reducer(state = INIT_STATE, action) {
  switch (action.type) {
    case types.QUESTION_LIST_INCREMENT_COOKIE:
      return {
        ...state,
        status: loadingState.LOADING,
      };
    case types.QUESTION_LIST_INCREMENT_COOKIE_SUCCESS:
      return {
        ...state,
        status: loadingState.READY,
        questionListCurrentStage: action.payload.currentStage,
        chatCurrentStage: INIT_STATE.chatCurrentStage,
      };
    case types.CHAT_INCREMENT_COOKIE:
      return {
        ...state,
        status: loadingState.LOADING,
      };
    case types.CHAT_INCREMENT_COOKIE_SUCCESS:
      return {
        ...state,
        status: loadingState.READY,
        chatCurrentStage: action.payload.currentStage,
      };
    case types.SKIP_CHAT_INCREMENT_COOKIE:
      return {
        ...state,
        chatCurrentStage: action.payload.currentStage,
      };
    default:
      return {
        ...state,
      };
  }
}

export default reducer;
export const getQuestionListCurrentStage = (state) =>
  state.tutorial.questionListCurrentStage;
export const getChatCurrentStage = (state) => state.tutorial.chatCurrentStage;



// WEBPACK FOOTER //
// ./src/services/redux/tutorial.js